export const getMenuLinks = (t) => ( [
  { title: t("menu_title_home"), link: "#" },
  { title: t("menu_title_how_it_works"), link: "#how-it-works" },
  { title: t("menu_title_features"), link: "#features" },
  { title: t("menu_title_team"), link: "#team" },
  { title: t("menu_title_faqs"), link: "#faqs" },
  { title: t("menu_title_contact"), link: "#contact" },
]);
